module.exports = __webpack_public_path__ + "assets/images/hospitalized_g.47acc08a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/hospitalized_g.png
// module id = 738
// module chunks = 1